const ErrorPage = () => (
    <main className='Main' data-testid='error-page-content'>
        <div className='ErrorPage'>
            <span className='rioglyph rioglyph-remove-circle ErrorPage__icon' />
            <h1 className='ErrorPage__title font-body text-h1 normal-case'>Access denied</h1>
            <p className='ErrorPage__text font-body'>You don&apos;t have permission to view this page.</p>
            <p className='ErrorPage__text font-body'>If you need access, contact your system admin.</p>
            <p className='ErrorPage__error font-body'>Error 403: Forbidden</p>
        </div>
    </main>
);

export default ErrorPage;
